import { render, staticRenderFns } from "./project-tile.vue?vue&type=template&id=446c89e8&scoped=true&"
import script from "./project-tile.vue?vue&type=script&lang=ts&"
export * from "./project-tile.vue?vue&type=script&lang=ts&"
import style0 from "./project-tile.vue?vue&type=style&index=0&id=446c89e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446c89e8",
  null
  
)

component.options.__file = "project-tile.vue"
export default component.exports